module.exports = __webpack_public_path__ + "static/img/left_image.5bf8a4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/left_image.png
// module id = xRXx
// module chunks = 37